import { AnyAction } from "redux"
import {
  SIGNIN_SUCCESS,
  SIGNIN_FAILURE,
  AUTHENTICATION_CHECK_SUCCESS,
  AUTHENTICATION_CHECK_ERROR,
  SIGN_OUT_SUCCESS,
  USER_PERSONAL_INFO_CALL,
  USER_PERSONAL_INFO_FAILURE,
  USER_PERSONAL_INFO_SUCCESS,
  SIGNIN_CALL
} from "./actions-types"

export interface User {
  name: string
  email: string
  role: string
}
export interface UserState {
  userLogin: {
    user: User
    loading: boolean
    error?: string
  }
  userSignout: {
    loading: boolean
    error?: string
  }
  authentication: {
    loading: boolean
    isAuthenticated: boolean
    hasError: boolean
  }
  userPersonalInfo: {
    data: {
      name: string
      isAgency: boolean
      email: string
    }
    loading: boolean
    error: string
  }
}

const INITIAL_STATE: UserState = {
  userLogin: {
    user: {
      name: "",
      email: "",
      role: ""
    },
    loading: false
  },
  userSignout: {
    loading: false
  },
  authentication: {
    loading: true,
    isAuthenticated: false,
    hasError: false
  },
  userPersonalInfo: {
    data: {
      name: "",
      isAgency: true,
      email: ""
    },
    loading: false,
    error: ""
  }
}

//This redux reducer is used to manage the state of the user login and signout
export default function userReducer(state: UserState = INITIAL_STATE, action: AnyAction): UserState {
  switch (action.type) {
    case SIGNIN_CALL:
      return {
        ...state,
        userLogin: { ...state.userLogin, error: undefined, loading: true }
      }
    case SIGNIN_SUCCESS:
      return {
        ...state,
        userLogin: {
          user: action.payload.user,
          loading: false
        },
        authentication: {
          loading: false,
          isAuthenticated: true,
          hasError: false
        }
      }
    case SIGNIN_FAILURE:
      return {
        ...state,
        userLogin: {
          ...state.userLogin,
          error: action.payload.error,
          loading: false
        },
        authentication: {
          loading: false,
          isAuthenticated: false,
          hasError: true
        }
      }
    case SIGN_OUT_SUCCESS:
      return {
        ...state,
        userSignout: { loading: false },
        authentication: {
          loading: false,
          isAuthenticated: false,
          hasError: false
        }
      }
    case AUTHENTICATION_CHECK_SUCCESS:
      return {
        ...state,
        authentication: {
          isAuthenticated: true,
          loading: false,
          hasError: false
        }
      }
    case AUTHENTICATION_CHECK_ERROR:
      return {
        ...state,
        authentication: {
          isAuthenticated: false,
          loading: false,
          hasError: true
        }
      }

    case USER_PERSONAL_INFO_CALL:
      return {
        ...state,
        userPersonalInfo: {
          ...state.userPersonalInfo,
          loading: true
        }
      }

    case USER_PERSONAL_INFO_FAILURE:
      return {
        ...state,
        userPersonalInfo: {
          ...state.userPersonalInfo,
          error: action.payload,
          loading: false
        }
      }

    case USER_PERSONAL_INFO_SUCCESS:
      return {
        ...state,
        userPersonalInfo: {
          data: action.payload as UserState["userPersonalInfo"]["data"],
          loading: false,
          error: ""
        }
      }

    default:
      return state
  }
}
